import api from '../config/api';
import {
  LocalVideoItem,
  StorageSummary,
  PaginatedVideosResponse,
  LocalVideoStatus,
} from '../types/LocalVideo';

export const LocalVideoService = {
  getVideos: async (status?: LocalVideoStatus | '', page = 1, limit = 20): Promise<PaginatedVideosResponse> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    params.append('page', String(page));
    params.append('limit', String(limit));
    const res = await api.get<PaginatedVideosResponse>(`/videos/local?${params.toString()}`);
    return res.data;
  },

  getSummary: async (): Promise<StorageSummary> => {
    const res = await api.get<StorageSummary>('/videos/local/summary');
    return res.data;
  },

  dispatchGcs: async (attachmentId: number): Promise<{ success: boolean; message: string }> => {
    const res = await api.post(`/videos/local/${attachmentId}/dispatch-gcs`);
    return res.data;
  },

  dispatchAllPending: async (maxBatch = 20): Promise<{ dispatched_count: number; dispatched_ids: number[] }> => {
    const res = await api.post('/videos/local/dispatch-all', { max_batch: maxBatch });
    return res.data;
  },

  deleteLocalFile: async (
    attachmentId: number,
    force = false
  ): Promise<{ success: boolean; bytes_freed_formatted: string }> => {
    const res = await api.delete(`/videos/local/${attachmentId}/file`, { data: { force } });
    return res.data;
  },
};

export default LocalVideoService;
